<template>
	<div>
		<div class="gPageBorder">
			<el-row style="margin-bottom:24px">

				<el-col :span="8" style="">
					<!-- <el-button v-show='isCreate' class='gSgLeftBtn'  type="primary" @click="add"  >{{$t('lin_global.cjzs')}}</el-button> -->
					<el-button v-show='isCerUpload' class='gSgLeftBtn' type="primary" @click="uploadCer">
						{{$t('app_upload')}}{{$t('lin_global.zhengshu')}}
					</el-button>
				</el-col>

				<el-col :offset="4" :span="4">
					<div class='gCtrl'>
						<el-select v-model="ctype" clearable :placeholder="$t('app_type')" @change='query'>
							<el-option v-for="item in ctyps" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gCtrl'>
						<MechanismSelector style='' :data="mechanismData"></MechanismSelector>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_name')" v-model='queryKey' @keyup.enter.native='query'
							icon="search" :on-icon-click="query"></el-input>
					</div>
				</el-col>

			</el-row>
			<el-table class='' v-loading="loading" :data="tableData2" id="tp" border @sort-change='sortChange'
				style="margin-bottom: 20px;" @row-click="rowClick">

				<el-table-column prop="certificateName" sortable="custom" :label="$t('lin_global.certificateName')">

				</el-table-column>
				<el-table-column prop="certificateDesc" :label="$t('lin_global.remark')">

				</el-table-column>
				<el-table-column prop="distributorName" :label="$t('lin_global.label_areaid')">

				</el-table-column>
				<el-table-column align="center" prop="certificateType" :label="$t('terminal.details.animatType')"
					width="">
					<template slot-scope="scope">
						<el-tag type="primary" v-if="scope.row.certificateType == '2'">{{$t('lin_global.cszss')}}
						</el-tag>
						<el-tag type="success" v-if="scope.row.certificateType == '1'">{{$t('lin_global.khzss')}}
						</el-tag>
					</template>

				</el-table-column>

				<el-table-column prop="createTime" sortable="custom" :label="$t('lin_global.createTime')" width="200">

				</el-table-column>
				<el-table-column align='left' :label="$t('lin_global.ope')" width="110">
					<template slot-scope="scope">

						<!-- <el-button @click.stop="xiafaRow(scope.row.certificateName,scope.row.certificateType,scope.row.distributorid,scope.row.distributorName,scope.row.certificateId)" type="text">{{$t('lin_global.xiafa')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('lin_global.xiafa')" placement="top">
							<el-button type='text'
								@click.stop="xiafaRow(scope.row.certificateName,scope.row.certificateType,scope.row.distributorid,scope.row.distributorName,scope.row.certificateId, scope.row)">
								<i class="fa fa-download" style=""></i>
							</el-button>
						</el-tooltip>

						<!-- <el-button @click.stop="importRow(scope.row.certificateId)" type="text">{{$t('lin_global.daochugongyao')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('lin_global.daochugongyao')"
							placement="top">
							<el-button type='text' @click.stop="importRow(scope.row.url)"><i class="fa fa-share-square"
									style=""></i></el-button>
						</el-tooltip>

						<!-- <el-button v-if="isCreate || (!isCreate && scope.row.certificateType!=='2')" @click.stop="deleteRow(scope.row.certificateId)" type="text">{{$t('lin_btn.delete')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button v-if="isCreate || (!isCreate && scope.row.certificateType!=='2')" type='text'
								@click.stop="deleteRow(scope.row.certificateId)"><i class="fa fa-trash"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>
			<div class="gPgDiv" v-if="totalRecords > 0">
				<el-pagination style='' class='gPg' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
				</el-pagination>
			</div>
		</div>
		<el-dialog class='gDia' :title="$t('lin_global.xiafa')" v-model="xiafaVisible">
			<el-form class='gDiaTable' ref="addForm" :model="form" :rules="rules" label-width="22.5%">
				<el-form-item :label="$t('lin_global.certificateName')">
					{{zhengshu}}
				</el-form-item>
				<el-form-item :label="$t('lin_global.qudaoshangxinxi')">
					{{qudaoshangxinxi}}
				</el-form-item>
				<!--<el-form-item :label="$t('lin_global.label_areaid')" prop="distributorId">
        <el-select id="mechanismId" v-model="form.distributorId" filterable clearable :placeholder="$t('lin_global.place_areaid')" style="width:100%">
          <el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">
          </el-option>
        </el-select>
      </el-form-item>-->
				<el-form-item :label="$t('lin_global.tslxxx')">
					<el-select @change="changeType" filterable clearable v-model="form.pushType" style="width:100%">
						<el-option v-for="item in type" :key="item.typeid" :label="item.typename" :value="item.typeid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="isShow" :label="$t('lin_global.label_areaid')" prop="terminalNo">
					<el-select filterable clearable v-model="form.terminalNo"
						:placeholder="$t('lin_global.place_areaid')" style="width:100%">
						<el-option v-for="item in areaList" :key="item.mechanismid" :label="item.mechanismname" :value="item.mechanismid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="!isShow" :label="$t('lin_global.label_no')" prop="terminalNo">
					<!--<el-input v-model="form.terminalNo"></el-input>-->
					<AutoTerno @on-result-change="onDvInputChange"></AutoTerno>
					<!-- <el-autocomplete
          class="inline-input"
          style="width: 100%"
          v-model="form.terminalNo"
          :fetch-suggestions="querySearch">
        </el-autocomplete> -->
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="isSubmit" style="margin-right: 74%;" @click="xiafaSubmit">
						{{$t('lin_global.xiafa')}}
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import city from '../city.js'
	// import sFile from 'save-file'
	import AutoTerno from '../global/TernoAutoCtrl'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			AutoTerno,
			MechanismSelector
		},
		data() {
			var that = this
			return {
				orderName: '',
				orderType: '',
				mechanismData: {
					callback(value) {
						that.mech = value
						that.query()
					}
				},
				mech: '',
				ctyps: [{
						vl: '',
						lb: this.$t('lin_global.allType')
					},
					{
						vl: '1',
						lb: this.$t('lin_global.khzss')
					},
					{
						vl: '2',
						lb: this.$t('lin_global.cszss')
					}
				],
				ctype: '',
				queryKey: '',
				ahref: '',
				form: {
					pushType: '2',
					terminalNo: '',
					type: '',
					zl: 'XZZS',
					certificateId: ''
				},
				rules: {
					'terminalNo': [{
						required: true,
						message: this.$t('lin_global.quorter')
					}]
				},
				type: [{
					typename: this.$t('lin_global.label_areaid'),
					typeid: '2'
				}, {
					typename: this.$t('lin_global.shebei'),
					typeid: '1'
				}],
				sel: [],
				sel2: [],
				options: city,
				focusEvent: focusEvent,
				riskId: '',
				radius: '',
				citys: '',
				radius2: '',
				citys2: '',
				input1: '',
				value1: '',
				areaList1: [],
				ifshow: true,
				ifshow2: true,
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogTopMgVisible: false,
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				currentPage1: 1,
				pageSize1: 10,
				totalRecords1: 0,
				areaList: [],
				arrdata1: [],
				tableData2: [],
				xiafaVisible: false,
				zhengshu: '',
				qudaoshangxinxi: '',
				qudaoshangid: '',
				zhengshutype: '',
				isShow: true,
				isSubmit: false,
				restaurants: [],
				loading: true,
			}
		},
		created() {
			this.getData(1);
			this.getData1(1, '', '');
			this.getAd1();
		},
		computed: {
			isCreate() {
				return localStorage.userType === '0'
			},
			isCerUpload() {
				// return localStorage.cerType === '0'
				return true
			}
		},
		methods: {
			sortChange(vl) {
				switch (vl.prop) {
					case 'certificateName':
						this.orderName = '1'
						break
					case 'createTime':
						this.orderName = '2'
						break
				}
				this.orderType = vl.order == 'descending' ? 'desc' : 'asc'
				this.getData(this.currentPage)
			},
			query() {
				this.getData(this.currentPage)
			},
			onDvInputChange(vl) {
				//this.value1 = vl

				this.form.terminalNo = vl
			},
			rowClick: function(row) {
				this.$router.push({
					path: '/certificate/' + row.certificateId + '/detail'
				})
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					var boo = (restaurant.value.indexOf(queryString) === 0)
					return boo;
				};
			},
			getNoList: function() {
				var params = {
					mechId: this.qudaoshangid
				};
				axios.post(`${baseurl}/terminal/terminalNoList.do`, params).then(res => {
					console.log('r', res.data.data)
					this.restaurants = res.data.data;
				})
			},
			xiafaSubmit: function() {
				var params = this.form;
				//console.log(params)

				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						axios.post(`${baseurl}/cmd/doCommand.do`, params).then(res => {
							if (res.data.status == 200) {
								this.$message(res.data.message);
								this.isSubmit = false;
								this.xiafaVisible = false;
							} else {
								this.isSubmit = false;
								this.$message.error(res.data.message)
							}
						})
					} else {
						this.$message.error(this.$t('lin_global.refs'))
						return false
					}
				})

			},
			changeType: function() {
				this.form.terminalNo = '';
				if (this.form.pushType == '2') {
					this.isShow = true
				} else {
					this.isShow = false
				}
			},
			formatStatus: function(row, column) {
				return row.certificateType == "2" ? this.$t('lin_global.cszss') : row.certificateType == "1" ? this.$t(
					'lin_global.khzss') : '';
			},
			cityFormat: function(row) {
				if (row.city) {
					var value = row.city.split(',')[0];
					return value
				}

			},
			hasValue: function(result, v, name) {
				if (!v[name] || v[name] === "") {
					return true;
				}
				return result.some((re) => v[name] === re);
			},
			selEvent: function(val) {

				var result = val.toString().split(',');
				var arr = this.options.filter(v => {
					if (this.hasValue(result, v, "value")) {
						if (v.children && v.children.length > 0) {
							v.children = v.children.filter(child => {
								if (this.hasValue(result, child, "value")) {
									return child
								}
								return false;
							});
							return v
						} else {
							return v
						}
					}
				})
				//console.log("打印城市")
				//console.log(arr);
				if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0]
					.value === "500000") {
					this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
				} else {
					this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[
						0].value;
				}
				//alert(this.citys);
			},
			selEvent2: function(val) {

				var result = val.toString().split(',');
				var arr = this.options.filter(v => {
					if (this.hasValue(result, v, "value")) {
						if (v.children && v.children.length > 0) {
							v.children = v.children.filter(child => {
								if (this.hasValue(result, child, "value")) {
									return child
								}
								return false;
							});
							return v
						} else {
							return v
						}
					}
				})
				//console.log("打印城市")
				//console.log(arr);
				if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0]
					.value === "500000") {
					this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
				} else {
					this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[
						0].value;
				}
				//alert(this.citys);
			},
			getAd1: function() {
				var params = {
					page: 1,
					rows: 10000
				};


				/*axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
				  //console.log(res.data);
				  var obj={
				    'mechanismname':this.$t('lin_global.all_mechanism'),
				    'mechanismid':''
				  }
				  this.areaList1 = res.data.data;
				  if(this.areaList1){
				    this.areaList1.unshift(obj)
				  } 
				})*/
			},
			getData1(page, no, areaid) {

				this.currentPage1 = page;
				var params = {
					page: page,
					rows: this.pageSize1,
					areaid: areaid,
					terminal_no: no,
					terminal_status: '',
					terminal_runtime_status: ''
				}
				//console.log("打印传出参数");
				//console.log(params);
				axios.post(`${baseurl}/terminal/list.do`, params).then(res => {
					//console.log("打印返回列表");
					//console.log(res.data);
					this.arrdata1 = res.data.data;
					this.totalRecords1 = res.data.total;
				}).catch(function(error) {

				})
			},
			statusChange() {
				this.getData1(1, this.input1, this.value1)
			},
			handleIconClick() {
				this.getData1(1, this.input1, this.value1)
			},
			deleteRow: function(id) {
				var params = {
					id: id
				}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/cer/deleteCertificate.do`, params).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData(1);
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},
			xiafaRow: function(name, type, id, idname, zhid, row) {
				console.log('row url : ' + row.url)

				this.xiafaVisible = true;
				this.qudaoshangxinxi = idname;
				this.zhengshu = name;
				this.qudaoshangid = id;
				this.form.type = type;
				this.form.certificateId = zhid;
				this.form.terminalNo = '';
				this.form.pushType = '2';
				this.form.url = row.url
				this.getAd();
				this.getNoList();
			},
			importRow: function(url) {
				var href = urlAssets.prefix + url;
				console.log('download url is: ' + href)
				window.open(href)
			},
			change2: function() {
				if (this.form2.controlType == '0') {
					this.ifshow2 = true;
				} else {
					this.ifshow2 = false;
				}
			},
			handleSizeChange1: function(val) {
				this.pageSize1 = val
				this.getData1(this.currentPage1)
			},
			handleCurrentChange1: function(val) {
				this.currentPage1 = val
				this.getData1(this.currentPage1)
			},
			handleSelectionChange1(val) {
				this.multipleSelection1 = val
			},
			bindRow(id) {
				var params = {
					riskId: this.riskId,
					terminalId: id,
					status: '0'
				}
				this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/risk/bindingTerminal.do`, params).then(res => {
						//console.log("打印类型")
						//console.log(res.data.data)
						if (res.data.status == '200') {
							this.$message.success(this.$t('lin_global.bdcg'))
							//this.getList(1);
							this.dialogTopMgVisible = false;
						} else {
							this.$message.error(res.data.message)
						}
					})
				})
			},
			batchBindRow() {
				if (this.multipleSelection1.length === 0) {
					this.$message.error(this.$t('lin_global.qxzybddzd'))
					return false
				} else {
					this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
						confirmButtonText: this.$t('lin_btn.confirm'),
						cancelButtonText: this.$t('lin_btn.cancel'),
						type: 'warning'
					}).then(() => {
						let ids = []

						for (let i = 0; i < this.multipleSelection1.length; i++) {
							ids.push(this.multipleSelection1[i].terminalId)
						}
						let rq = ids.join(',');
						var params = {
							riskId: this.riskId,
							terminalId: rq,
							status: '0'
						};
						axios.post(`${baseurl}/risk/bindingTerminal.do`, params).then(res => {
							//console.log("打印类型")
							//console.log(res.data.data)
							if (res.data.status == '200') {
								this.$message.success(this.$t('lin_global.bdcg'))
								//this.getList(1);
								this.dialogTopMgVisible = false;
							} else {
								this.$message.error(res.data.message)
							}
						})
					}).catch(() => {

					})
				}

			},
			submit2: function() {
				this.params = {};
				if (this.form2.controlType == '0') {
					this.params.id = this.riskId;
					this.params.radius = this.radius2;
					this.params.controllerName = this.form2.controllerName;
					this.params.controllerDesc = this.form2.controllerDesc;
					this.params.messageId = this.form2.messageId;
					this.params.controlType = this.form2.controlType;
				} else {
					this.params.id = this.riskId;
					this.params.city = this.citys2;
					this.params.controllerName = this.form2.controllerName;
					this.params.controllerDesc = this.form2.controllerDesc;
					this.params.messageId = this.form2.messageId;
					this.params.controlType = this.form2.controlType;
				}
				//console.log("打印参数");
				//console.log(this.params);
				var params = this.params;
				axios.post(`${baseurl}/risk/editRisk.do`, params).then(res => {
					//console.log("打印看看编辑返回信息")
					//console.log(res.data);
					if (res.data.status == 200) {
						this.dialogFormVisible2 = false;
						this.$message.success(res.data.message);
						this.getData(1, '', '');
					} else {
						this.dialogFormVisible2 = false;
						this.$message.error(res.data.message)
					}
				})
			},
			getDetail: function() {
				var params = {
					riskId: this.riskId
				};
				this.sel2 = [];
				axios.post(`${baseurl}/risk/getByIdRisk.do`, params).then(res => {
					//console.log("打印围栏详情")
					//console.log(res.data);
					this.form2.controllerName = res.data.data.controlName;
					this.form2.controllerDesc = res.data.data.controlDesc;
					this.form2.messageId = res.data.data.messageid;
					if (res.data.data.controlType == '0') {
						this.ifShow2 = true;
						this.ifshow2 = true;
						this.form2.controlType = '0';
						this.radius2 = res.data.data.radius;
					} else {
						this.ifShow2 = false;
						this.ifshow2 = false;
						this.form2.controlType = '1'
						this.citys2 = res.data.data.city;
						var arr = res.data.data.city.split(',');

						this.sel2.push(arr[1]);
						this.sel2.push(arr[2]);
					}
				})
			},
			submit: function() {
				this.params = {};
				if (this.form.controlType == '0') {
					this.params.radius = this.radius;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				} else {
					this.params.city = this.citys;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				}
				//console.log("打印参数");
				//console.log(this.params);
				var params = this.params;
				axios.post(`${baseurl}/risk/addRisk.do`, params).then(res => {
					//console.log("打印看看登陆信息")
					//console.log(res.data);
					if (res.data.status == 200) {
						this.dialogFormVisible = false;
						this.$message.success(res.data.message);
						this.getData(1);
					} else {
						this.dialogFormVisible = false;
						this.$message.error(res.data.message)
					}
				})
			},
			onCancel: function() {
				this.dialogFormVisible = false;
			},
			onCancel2: function() {
				this.dialogFormVisible2 = false;
			},
			change: function() {
				if (this.form.controlType == '0') {
					this.ifshow = true;
				} else {
					this.ifshow = false;
				}
			},
			getAd: function() {
				/*this.$getChannelList(10000, 1, (res) => {
				  
				  this.areaList = res.data
				}, '') */

				var params = {
					page: 1,
					rows: 10000,
					mechId: this.qudaoshangid
				};
				axios.post(`${baseurl}/mechanism/list.do`, params).then(res => {
					//console.log(res)
					this.areaList = res.data.data;
				})
			},
			uploadCer() {
				this.$setWObj('safeCerType', 1)
				this.$router.push({
					path: '/certificate/upload'
				})
			},
			add: function() {
				this.$router.push({
					path: '/certificate/new'
				})
			},
			upload: function() {
				this.$router.push({
					path: '/certificate/upload'
				})
			},
			linkDetail: function(row) {
				//console.log(row.id)
				this.$router.push({
					path: '/rail/' + row.id + '/detail'
				})
			},
			handleSizeChange: function(val) {
				this.pageSize = val
				this.getData(this.currentPage)
			},
			handleCurrentChange: function(val) {
				this.currentPage = val
				this.getData(this.currentPage)
			},
			getData(page) {
				this.currentPage = page;
				var params2 = {
					page: page,
					rows: this.pageSize,
					certType: this.ctype,
					userMechId: this.mech,
					certName: this.queryKey,
					orderName: this.orderName,
					orderType: this.orderType
				};
				//console.log("打印传餐");
				//console.log(params2)
				axios.post(`${baseurl}/cer/listCertificate.do`, params2).then(res => {
					//console.log("打印返回列表2");
					//console.log(res.data);
					if (res.data.status == 200) {
						this.tableData2 = res.data.data;
						this.totalRecords = res.data.total;
						this.loading = false;
					} else {
						this.loading = false;
					}

				})
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// certificate.vue?45dd4029